import type { ReactNode } from "react";

import { cn } from "@/utils/cn";

import Text from "@/components/text";

interface EmptyStateProps {
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}

/** The mini app's centred empty state, sized for a section rather than a screen. */
export default function EmptyState({ title, description, action, className }: EmptyStateProps) {
  return (
    <div
      data-slot="empty-state"
      className={cn("flex w-full flex-col items-center justify-center gap-4 px-6 py-16 text-center", className)}
    >
      <div className="flex max-w-sm flex-col items-center gap-1.5">
        <Text size="subtitle" weight="semibold">
          {title}
        </Text>
        {description && <Text.Hint className="text-pretty">{description}</Text.Hint>}
      </div>
      {action && <div className="pt-1">{action}</div>}
    </div>
  );
}
